// Diretiva v-auto-grow: o textarea cresce até mostrar o texto inteiro.
// O estilo base (_base.scss) fixa todo textarea em h-16, o que ignora o
// "rows" e corta a mensagem sugerida em duas linhas. field-sizing: content
// resolveria, mas o Safari não suporta.
const listeners = new WeakMap();

const fit = el => {
  el.style.height = 'auto';
  el.style.height = `${el.scrollHeight + 4}px`;
};

export const vAutoGrow = {
  mounted(el) {
    const onInput = () => fit(el);
    listeners.set(el, onInput);
    el.style.overflowY = 'hidden';
    el.addEventListener('input', onInput);
    requestAnimationFrame(onInput);
  },
  updated(el) {
    fit(el);
  },
  unmounted(el) {
    const onInput = listeners.get(el);
    if (onInput) el.removeEventListener('input', onInput);
    listeners.delete(el);
  },
};
